import { render, staticRenderFns } from "./sit-and-stand-a45.vue?vue&type=template&id=df98cd9c"
import script from "./sit-and-stand-a45.vue?vue&type=script&lang=js"
export * from "./sit-and-stand-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports